@if ((!failed &&
  canLoadScript &&
  (isHidden$ | async) !== true &&
  (remark | dsListMetricProps: 'data-badge-enabled':isListElement == true))) {
  <div class="d-flex flex-nowrap flex-row gapx-3 align-items-center pe-3"
    >
    <div #metricChild>
      <div
        class="altmetric-embed"
        [attr.data-hide-no-mentions]="visibleWithoutData ? false : (remark | dsListMetricProps : 'data-hide-no-mentions' : isListElement)"
        [attr.data-hide-less-than]="remark | dsListMetricProps : 'data-hide-less-than' : isListElement"
        [attr.data-badge-details]="remark | dsListMetricProps : 'data-badge-details' : isListElement"
        [attr.data-badge-type]="remark | dsListMetricProps : 'badgeType' : isListElement"
        [attr.data-badge-popover]="remark | dsListMetricProps : 'popover' : isListElement"
        [attr.data-doi]="remark | dsListMetricProps : 'doiAttr' : isListElement"
        [attr.data-pmid]="remark | dsListMetricProps : 'pmidAttr' : isListElement"
        [attr.data-link-target]="remark | dsListMetricProps : 'data-link-target' : isListElement"
      ></div>
    </div>
    @if (!hideLabel && (showAltmetricLabel$ | async)) {
      <div class="fw-bold">
        {{ "item.page.metric.label." + metric.metricType | translate }}
      </div>
    }
  </div>
}
@if (!canLoadScript && !isListElement) {
  <div class="row d-flex align-items-center justify-content-center m-2" >
    <div>
      {{ "third-party-metrics-cookies.message" | translate: {metricType: metric.metricType | titlecase} }}
      <div role="button" class="btn-link" (click)="requestSettingsConsent.emit(true)">{{"third-party-metrics-cookies.consent-settings" | translate}}</div>
    </div>
  </div>
}
